import { DateTime } from 'luxon'

export const getCurrentMonthWeek = (dateTime) => {
  const firstDayOfMonth = DateTime.fromObject({
    year: parseInt(dateTime.toFormat('yyyy')),
    month: dateTime.toFormat('L'),
  })
  
  return (`${
    parseInt(dateTime.toFormat('W')) -
    parseInt(firstDayOfMonth.toFormat('W')) +
    1
  }`)
}